import { render, staticRenderFns } from "./SelectVatPercentage.vue?vue&type=template&id=f931fcce&"
import script from "./SelectVatPercentage.vue?vue&type=script&lang=js&"
export * from "./SelectVatPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports